import { Router, NavigationEnd } from "@angular/router";
import { DOCUMENT } from "@angular/common";
import {
  Component,
  Inject,
  ElementRef,
  OnInit,
  Renderer2,
  HostListener,
  OnDestroy,
} from "@angular/core";

import { ROUTES } from "./sidebar-items";
import { AuthenticationService } from "src/app/_services/authentication.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Subscription } from "rxjs";
import { RouteInfo } from "./sidebar.metadata";
import * as _ from "lodash";
import { IAccount } from 'src/app/_models/account/IAccount';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { ConfigurationService } from "src/app/_services/configuration.service";
import { IConfiguration } from "src/app/_models/configuration/IConfiguration";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.sass"],
})
export class SidebarComponent implements OnInit, OnDestroy {
  subscriptions = new Subscription();
  public sidebarItems: RouteInfo[] = [];
  showMenu = "dashboard";
  showSubMenu = "";
  showSubSubMenu = "";
  public innerHeight: any;
  public bodyTag: any;
  listMaxHeight: string;
  listMaxWidth: string;
  userFullName: string;
  userImg: string;
  roleNames: string;
  headerHeight = 60;
  currentRoute: string;
  localRoutes: RouteInfo[] = [];
  account: IAccount;
  version = "";
  versionDate = "";
  isAdmin = false;
  customPublicInterface = false;
  hideAppointmentsModule = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public elementRef: ElementRef,
    private authenticationService: AuthenticationService,
    private router: Router,
    private snackBar: MatSnackBar,
    private spinner: NgxSpinnerService,
    private configurationService: ConfigurationService
  ) {
    const sub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.split("/")[1] === "multilevel") {
          this.showMenu = event.url.split("/")[1];
        } else {
          this.showMenu = event.url.split("/").slice(2)[0];
        }
        this.showSubMenu = event.url.split("/").slice(2)[0];
      }
    });
    this.subscriptions.add(sub);
  }
  @HostListener("window:resize", ["$event"])
  windowResizecall(event) {
    this.setMenuHeight();
    this.checkStatuForResize(false);
  }
  @HostListener("document:mousedown", ["$event"])
  onGlobalClick(event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.renderer.removeClass(this.document.body, "overlay-open");
    }
  }
  callMenuToggle(event: any, element: any) {
    if (element === this.showMenu) {
      this.showMenu = "0";
    } else {
      this.showMenu = element;
    }
    const hasClass = event.target.classList.contains("toggled");
    if (hasClass) {
      this.renderer.removeClass(event.target, "toggled");
    } else {
      this.renderer.addClass(event.target, "toggled");
    }
  }
  callSubMenuToggle(event: any, element: any) {
    if (element === this.showSubMenu) {
      this.showSubMenu = "0";
    } else {
      this.showSubMenu = element;
    }
    // close menu on mobile
    this.renderer.removeClass(this.document.body, "overlay-open");
  }
  closeMenu(className: string) {
    if (className !== "menu-toggle") {
      // close menu on mobile
      this.renderer.removeClass(this.document.body, "overlay-open");
    }
  }

  ngOnInit() {
    this.getConfigurations();

    // custom public interface
    if (environment.customInterface) {
      this.customPublicInterface = true;
    }
    
    if (this.authenticationService.isAuthenticated()) {
      this.isAdmin = this.authenticationService.isAdmin();
      this.localRoutes = _.cloneDeep(ROUTES);
      this.account = this.authenticationService.getAccount();
      this.version = environment.VERSION;
      this.versionDate = environment.VERSION_DATE;
    }

    // this.sidebarItems = ROUTES.filter((sidebarItem) => sidebarItem);
    this.initLeftSidebar();
    this.bodyTag = this.document.body;
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  initLeftSidebar() {
    const _this = this;
    // Set menu height
    _this.setMenuHeight();
    _this.checkStatuForResize(true);
  }
  processMenuItems() {
    const sub = this.authenticationService.account.subscribe(
      (res: IAccount) => {
        if (res) {
          this.userFullName = res.person.lastName + ' ' + res.person.firstName;
          const accountRoles = res.roles;

          /**
           * parcurgem fiecare element din meniu si verificam daca rolurile userului
           * se regasesc in rolurile permise din elementul meniului;
           * daca un element nu are definite roluri, atunci el va fi afisat pentru toate rolurile
           */
          
          this.sidebarItems = [];
          for (let i = 0; i < this.localRoutes.length; i++) {
            const processedRoute = this.processRoute(this.localRoutes[i], accountRoles);
            if (processedRoute) {
              // daca avem activa configurarea de ascundere modul programari, atunci se va trece mai departe
              if (processedRoute.moduleName === 'appointments' && this.hideAppointmentsModule) {
                continue;
              }

              this.sidebarItems[i] = processedRoute;

              // parcurgere si verificare roluri, similar parintelui
              if (processedRoute.submenu.length > 0) {
                const aux: RouteInfo[] = [];
                for (const subItem of processedRoute.submenu) {
                  const processedSubRoute = this.processRoute(subItem, accountRoles);
                  if (processedSubRoute) {
                    aux.push(processedSubRoute);
                  }
                }
                if (aux.length > 0) {
                  this.sidebarItems[i].submenu = aux;
                }
              }
            }
          }

          this.sidebarItems = this.sidebarItems.filter((x) => {
            return true;
          });

          const sortedRoles = accountRoles.sort((a, b) => {
            return a.mapping - b.mapping;
          });
          this.roleNames = sortedRoles.map((x) => x.name).join(", ");
        }
      }
    );

    this.subscriptions.add(sub);
  }
  setMenuHeight() {
    this.innerHeight = window.innerHeight;
    const height = this.innerHeight - this.headerHeight;
    this.listMaxHeight = height + "";
    this.listMaxWidth = "500px";
  }
  isOpen() {
    return this.bodyTag.classList.contains("overlay-open");
  }
  checkStatuForResize(firstTime) {
    if (window.innerWidth < 1170) {
      this.renderer.addClass(this.document.body, "ls-closed");
    } else {
      this.renderer.removeClass(this.document.body, "ls-closed");
    }
  }
  mouseHover(e) {
    const body = this.elementRef.nativeElement.closest("body");
    if (body.classList.contains("submenu-closed")) {
      this.renderer.addClass(this.document.body, "side-closed-hover");
      this.renderer.removeClass(this.document.body, "submenu-closed");
    }
  }
  mouseOut(e) {
    const body = this.elementRef.nativeElement.closest("body");
    if (body.classList.contains("side-closed-hover")) {
      this.renderer.removeClass(this.document.body, "side-closed-hover");
      this.renderer.addClass(this.document.body, "submenu-closed");
    }
  }
  logOut() {
    this.spinner.show();
    const sub = this.authenticationService.doLogout().subscribe(
      (res: boolean) => {
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        if (error) {
          this.showNotification("snackbar-danger", error, "bottom", "right");
        }
      },
      () => {
        this.spinner.hide();
      }
    );
    this.subscriptions.add(sub);
  }
  private processRoute(route: RouteInfo, roles: any[]) {
    route.path = route.path.replace("{accountID}", this.account.id.toString());
    for (const role of roles) {
      if (route.role.length === 0 || route.role.indexOf(role.mapping) > -1) {
        return route as RouteInfo;
      }
    }

    return null;
  }
  private showNotification(colorName, text, placementFrom, placementAlign) {
    this.snackBar.open(text, "", {
      duration: 3000,
      verticalPosition: placementFrom,
      horizontalPosition: placementAlign,
      panelClass: colorName,
    });
  }
  private getConfigurations() {
    const sub = this.configurationService.getConfigurations().subscribe(
      (res: IConfiguration[]) => {
        let configs = res;

        let hideAppointmentsModuleAux = configs.find(x => x.key === 'hideAppointmentsModule');
        if (hideAppointmentsModuleAux && hideAppointmentsModuleAux.value == "1") {
          this.hideAppointmentsModule = true;
        }

        if (this.authenticationService.isAuthenticated()) {
          this.processMenuItems();
        }
      });
    this.subscriptions.add(sub);
  }
}
